import type { ReactNode } from 'react'
import ShopSeoHead from './ShopSeoHead'
import type { ShopSeoData } from '../seo'
import type { ShopLocale } from '../../i18n'

type ShopPageShellProps = {
  seo: ShopSeoData
  siteUrl: string
  siteName: string
  faviconUrl: string
  locale: ShopLocale
  children: ReactNode
}

const ShopPageShell = ({
  seo,
  siteUrl,
  siteName,
  faviconUrl,
  locale,
  children,
}: ShopPageShellProps) => (
  <>
    <ShopSeoHead
      seo={seo}
      siteUrl={siteUrl}
      siteName={siteName}
      faviconUrl={faviconUrl}
      locale={locale}
    />
    {children}
  </>
)

export default ShopPageShell
